(function () {
  'use strict';

  function startWishlist() {
    if (typeof window.jQuery === 'undefined') {
      return;
    }

    var $ = window.jQuery;

    ;(function (Wishlist) {
      var $wishlistButton = $('.wishlist-btn');
      var $wishlistTile = $('.wishlist-tile-container');
      var $wishlitcounter = $('.wishlist-counter');
      var numProductTiles = $wishlistTile.length;

      var getStoredWishlist = function () {
        try {
          var raw = localStorage.getItem('user_wishlist');
          if (!raw) {
            return [];
          }
          var parsed = JSON.parse(raw);
          return Array.isArray(parsed) ? parsed : [];
        } catch (error) {
          return [];
        }
      };

      var syncWishlistCount = function (count) {
        var safeCount = Math.max(parseInt(count, 10) || 0, 0);
        localStorage.setItem('user_wishlist_count', String(safeCount));
        $wishlitcounter.html(String(safeCount));
      };

      var wishlist = getStoredWishlist();
      syncWishlistCount(wishlist.length);

      var animateWishlist = function (self) {
        $(self).toggleClass('is-active');
      };

      var updateWishlist = function (self) {
        var productHandle = $(self).attr('data-product-handle');
        var isRemove = $(self).hasClass('is-active');

        if (isRemove) {
          var removeIndex = wishlist.indexOf(productHandle);
          if (removeIndex > -1) {
            wishlist.splice(removeIndex, 1);
          }
        } else if (wishlist.indexOf(productHandle) === -1) {
          wishlist.push(productHandle);
        }

        localStorage.setItem('user_wishlist', JSON.stringify(wishlist));
        syncWishlistCount(wishlist.length);

        if (isRemove && window.location.href.indexOf('pages/wishlist') > -1) {
          $(self).closest('form.cart').remove();
          numProductTiles = $('.wishlist-tile-container').length;
          syncWishlistCount(numProductTiles);

          if (numProductTiles === 0) {
            $('.wishlist-grid-empty-list').addClass('is_visible').show();
            $('.wishlist-grid').hide();
          }
        }
      };

      var activateItemsInWishlist = function () {
        $wishlistButton.each(function () {
          var productHandle = $(this).attr('data-product-handle');
          if (wishlist.indexOf(productHandle) > -1) {
            $(this).addClass('is-active');
          }
        });
      };

      var displayOnlyWishlistItems = function () {
        $wishlistTile.each(function () {
          var productHandle = $(this).attr('data-product-handle');
          if (wishlist.indexOf(productHandle) === -1) {
            $(this).closest('form.cart').remove();
            numProductTiles--;
          }
        });
      };

      var loadWishlist = function () {
        if (window.location.href.indexOf('pages/wishlist') === -1) {
          return;
        }

        displayOnlyWishlistItems();
        syncWishlistCount(numProductTiles);

        var $loader = $('.wishlist-loader');
        var revealWishlist = function () {
          $('.wishlist-grid').addClass('is_visible');
          $('.wishlist-hero').addClass('is_visible');

          if (numProductTiles === 0) {
            $('.wishlist-grid-empty-list').addClass('is_visible').show();
            $('.wishlist-grid').hide();
          } else {
            $('.wishlist-grid-empty-list').removeClass('is_visible').hide();
            $('.wishlist-grid').show();
          }
        };

        if ($loader.length) {
          $loader.fadeOut(300, revealWishlist);
        } else {
          revealWishlist();
        }
      };

      var bindUIActions = function () {
        $wishlistButton.off('click.wishlist').on('click.wishlist', function (e) {
          e.preventDefault();
          updateWishlist(this);
          animateWishlist(this);
        });

        $(document).off('click.wishlistClear').on('click.wishlistClear', '#remove-done', function (e) {
          e.preventDefault();
          wishlist = [];
          localStorage.setItem('user_wishlist', JSON.stringify(wishlist));
          syncWishlistCount(0);
          window.location.reload();
        });
      };

      Wishlist.init = function () {
        $wishlistButton = $('.wishlist-btn');
        $wishlistTile = $('.wishlist-tile-container');
        $wishlitcounter = $('.wishlist-counter');
        numProductTiles = $wishlistTile.length;
        wishlist = getStoredWishlist();
        syncWishlistCount(wishlist.length);
        bindUIActions();
        activateItemsInWishlist();
        loadWishlist();
      };

      Wishlist.init();
    }(window.Wishlist = window.Wishlist || {}));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startWishlist);
  } else {
    startWishlist();
  }

  window.addEventListener('load', startWishlist);
})();

function reloadPage() {
  window.location.reload();
}
